import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
deleteVideosAction,
deleteVideosrelatedAction,
readLanguageAction,
readVideosAction,
saveCommonsUrlsAction,
saveDownloadVideoUrlLanguageAction,
saveVideoLanguageAction,
saveVideoPreviewLanguageAction,
saveVideoPreviewUrlsAction,
saveVideoUrlLanguageAction,
saveVideosAction,
saveVideosDownloadUrlsAction,
saveVideosThumbNailUrlsAction,
saveVideosUrlsAction,
saveVideosrelatedAction,
translateLanguageAction,
updateCommonsUrlsAction,
updateDownloadVideoUrlLanguageAction,
updateVideoLanguageAction,
updateVideoPreviewLanguageAction,
updateVideoPreviewUrlsAction,
updateVideoUrlLanguageAction,
updateVideosAction,
updateVideosDownloadUrlsAction,
updateVideosThumbNailUrlsAction,
updateVideosUrlsAction,
uploadAssestsAction,
uploadAssestsV2Action,
uploadVideosV2Action,
} from "../../../store/Languages/LanguageAction";
import Toastiy from "../../../components/universal/Toastiy";
import { useNavigate } from "react-router-dom";
import {
deleteVideoLayoutAction,
readVideoLayoutAction,
saveVideoLayoutAction,
updateVideoLayoutAction,
} from "../../../store/Layout/LayoutAction";
import { setShowNavigationAlertAction } from "../../../store/GlobalLoader/GlobalLoaderAction";
import { sendCustomNotificationAction } from "../../../store/Notifications/NotificationAction";
import { fetchChurchesRequest } from "../../../store/Churches/actions";
import { saveChurchRequest,deleteChurchRequest,updateChurchRequest } from "../../../store/Churches/actions"; // ✅ import save action
import {saveTeamRequest,updateTeamRequest,deleteTeamRequest} from '../../../store/Team/actions'
import {saveTeamCoverImageRequest,updateTeamCoverImageRequest} from '../../../store/TeamCoverImage/teamCoverImageActions'
import { saveLeadershipLanguageMetaRequest } from "../../../store/TeamLanguage/action";
import {saveTeamVideoRequest} from "../../../store/TeamVideo/teamVideoActions"
import { toast } from "react-toastify";

const ChurchHooks = () => {
const [value, setValue] = useState("");
const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};

return { value, onChangeSearchBar };
};

export default ChurchHooks;

export const AllChurchHooks = () => {
const dispatch = useDispatch();

const [value, setValue] = useState("");
const [reloadData, setReloadData] = useState(false);
const fetchAllChurches = (
    page,
    limit,
    searchCriteria = {},
    callbackFn,
    churchId = ""
  ) => {
        dispatch(
    fetchChurchesRequest({
      apiPayloadRequest: {
        page: page,
        limit: limit,
        searchCriteria: searchCriteria,
        _id: churchId
      },
      callback: (Data) => {
        // 🔍 Log full API response

        if (Data?.type === 1) {

          let allTeamMembers = (Data?.data ?? []).flatMap((church) =>
            (church.teammembers ?? []).map((member) => ({
              ...member,
              churchId: church._id,
            }))
          );

          // 🔍 Log flattened team members

          // ✅ Filter by churchId if selected
          if (churchId) {
            allTeamMembers = allTeamMembers.filter(
              (member) => member.churchId === churchId
            );
          }

          // 🔍 Log after filter

          if (callbackFn) {
            callbackFn({
              data: allTeamMembers,
              total: allTeamMembers.length,
            });
          }
        } else {
                    if (callbackFn) {
            callbackFn({ data: [], total: 0 });
          }
        }
      },
    })
  );

  };




const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};

const handleDelete = (row) => {
    return new Promise((resolve, reject) => {

      dispatch(
        deleteTeamRequest({
          _id: row.churchId,           // ✅ Church ID
          memberObjId: row.memberObjId, // ✅ Team member ID
          callback: (res) => {
            if (res?.type === 1) {
              toast.success("Team member deleted successfully");
              resolve(res); // ✅ Resolve promise on success
            } else {
              toast.error("Delete failed: " + res?.error);
              reject(res); // ❌ Reject promise on failure
            }
          },
        })
      );
    });
  };





const getVideoDeletedResponse = (data, message) => {
    if (data?.type === 1) {
    Toastiy(message, data?.type);
    } else {
    Toastiy("Issue performing the operation, contact admin!!", data?.type);
    }
};
return {
    value,
    onChangeSearchBar,
    handleDelete,
    reloadData,
    setReloadData,
    fetchAllChurches
};
};

export const AddChurchHooks = (setLoading, data) => {

// search logic here
const [options, setOptions] = useState([]);
const [value, setValue] = useState("");
const [activeTab, setActiveTab] = useState("en");
const [activeLanguageDetails, setActiveLanguageDetails] = useState({
    language_code: "en",
    language_name: "English",
});
const [allLanguageData, setAllLanguageData] = useState([]);
const [readLanguageData, setReadLanguageData] = useState([]);
const [selectedOptions, setSelectedOptions] = useState([]);
const [selectedRelatedVideoIndex, setSelectedRelatedVideoIndex] = useState(null);
const [relatedVideos, setRelatedVideos] = useState([]);
const [thumbnailImage, setThumbnailImage] =useState();
const [isLive,setIslive] =useState(false)
const [isDefault,setIsDefault] =useState(false)
const dispatch = useDispatch();
const [selectedVideos, setSelectedVideos] = useState([]);

const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};
// add category logic here

const initialLayoutValues = {
    _id: "",
    mobile_layout: "1",
    layout_name: "",
    order: "",
    // title: "",
    // subtitle: "",
    // expiry: "",
};

const initialVideoValues = {
    video_title: "",
    video_description: "",
    _id: "",
};

const [layoutValues, setLayoutValues] = useState(initialLayoutValues);
const [addedLayout, setAddedLayout] = useState(false);

const initialStateValues = {
    mobileUploadUrl: "",
    webUploadUrl: "",
    tabletUploadUrl: "",
};

const languages = [
    "English",
    "hindi",
    "tamil",
    "telugu",
    "Malayalam",
    "Spanish",
    "Marathi",
    "Urdu",
    "Oriya",
    "kanada",
    "Bengali",
]; // List of languages

const [downloadValues, setDownloadValues] = useState("");
const [downloadUrl, setDownloadUrl] = useState("");
const [thumbNailValues, setThumbNailValues] = useState("");
const [thumbNailUrl, setThumbNailUrl] = useState("");
const [inputs, setInputs] = useState("");
const [showVideoLibraryModal, setShowVideoLibraryModal] = useState(false);
const [videoInputs, setVideoInputs] = useState(initialVideoValues);
const [videoErrors, setVideoErrors] = useState({
    video_title: false,
    video_description: false,
    video_urls: false,
    video_download_urls: false,
    video_thumbnails_urls: false,
    video_common_thumbnails_urls: false,
    video_preview_urls: false,
    selectedOptions: false,
});

const [currentInputs, setCurrentInputs] = useState();
const [languagemeta, setLanguagemeta] = useState();

const [videoUrlsInputs, setVideoUrlsInputs] = useState(initialStateValues);
const [UdownloadrlsInputs, setDownloadUrlsInputs] = useState(initialStateValues);
const [tumbNailUrlsInputs, setTumbNailUrlsInputs] = useState(initialStateValues);
const [GalleryId, setGalleryId] = useState('');
const [ImageSet, setImageset] = useState('');

const [commonVideoUrlsInputs, setCommonUrlsInputs] = useState(initialStateValues);
const [previewUrlsInputs, setPreviewUrlsInputs] = useState(initialStateValues);

const [videoUrlsInputsCheck, setVideoUrlsInputsCheck] = useState();
const [UdownloadrlsInputsCheck, setDownloadUrlsInputsCheck] = useState();
const [tumbNailUrlsInputsCheck, setTumbNailUrlsInputsCheck] = useState();
const [commonUrlsInputsCheck, setCommonUrlsInputsCheck] = useState();
const [previewUrlsInputsCheck, setPreviewUrlsInputsCheck] = useState();
const [layoutInfo, setLayoutInfo] = useState(false);
const [layoutArray, setLayoutArray] = useState([]);
const [isLayoutEdit, setIsLayoutEdit] = useState(false);
const [editLayoutIndex, setEditLayoutIndex] = useState(null);
const [editTargetLayout, setEditTargetLayout] = useState("");

const initialChurchValues = {
    _id: "",
    church_id: "",
    memberName: "",
    memberDescription: "",
    memberDesignation: "",
    logo_url: "",

};
const [churchInputs, setChurchInputs] = useState(initialChurchValues);
const initialCarecellValues={
    type_of_url: "",
    url_link: "",
}
const [carecellInputs, setcarecellInputs] = useState(initialCarecellValues);
// 🔹 State for previous (existing) values when editing
const [previousChurchInputs, setPreviousChurchInputs] = useState({
    _id: "",
    church_name: "",
    church_description: "",
    church_address: "",
});

// 🔹 Validation errors
const [churchErrors, setChurchErrors] = useState({
    church_name: false,
    church_description: false,
    church_address: false,
});

// 🔹 Loader (renamed)
const [savingChurch, setSavingChurch] = useState(false);

// 🔹 Local store for churches (instead of DB)
const [churches, setChurches] = useState([]);
const [saveSuccess, setSaveSuccess] = useState(false);


const navigate = useNavigate();


// useEffect(() => {
//     return () => setShowNavigationAlert(false);
// }, []);

const setShowNavigationAlert = (value) => {
    dispatch(setShowNavigationAlertAction(value));
};

const combineStateKeys = (data) => {
      const values = Object.values({
      memberName: data?.memberName,
      memberDescription: data?.memberDescription,
      memberDesignation:data?.memberDesignation
    });
    const combinedString = values.join("///");
        return combinedString;
};

const updateStateWithTranslation = (data) => {
    const combinedText = combineStateKeys(data);

    dispatch(
    translateLanguageAction({
        apiPayloadRequest: {
        targetcode: activeTab,
        translatetext: combinedText,
        },
        callback: (res) => {
        if (res?.type === 1) {
            onTranslateSuccess(res?.data);
        } else if (res?.type === 2) {
            Toastiy("Language Translation failed!!");
            Toastiy(res?.message);
        }
        },
    })
    );
};

const onTranslateSuccess = (data) => {

        const arrayOfValues = data.split("///");
    const arrayOfKeys = Object.keys({
      memberName: churchInputs?.memberName,
    memberDescription: churchInputs?.memberDescription,
    memberDesignation:churchInputs?.memberDesignation
    });

    for (let key in arrayOfKeys) {
    setChurchInputs((preState) => ({
        ...preState,
        [arrayOfKeys[key]]: arrayOfValues[key],
    }));
    }
    setShowNavigationAlert(true);
};

// const getRelatedVideos = (response) => {
//     if (response?.type === 1) {
//     response?.data?.map((item) =>
//         setOptions((prevData) => [
//         ...prevData,
//         {
//             value: item?._id || "",
//             label: item?.video_title || "",
//             image: item?.tumbnailurls?.length > 0 ? item?.tumbnailurls[0]?.url_link : "",
//         },
//         ])
//     );
//     } else {
//     Toastiy("Failed To Get Related Videos Data");
//     }
// };

const handleAddLayoutToArray = () => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        saveVideoLayoutAction({
        apiPayloadRequest: {
            _id: layoutValues?._id,
            videoObjId: videoInputs?._id,
            order: layoutValues?.order,
            // expiry: layoutValues?.expiry,
            // title: layoutValues?.title,
            // subtitle: layoutValues?.subtitle,
        },
        callback: (res) => {
            if (res?.type === 1) {
            Toastiy("Layout Added Successfully!", 1);
            setLayoutArray((prev) => [...prev, layoutValues]);
            setLayoutValues(initialLayoutValues);
            setAddedLayout(true);
            }
        },
        })
    );
    } else {
    setLayoutArray((prev) => [...prev, layoutValues]);
    setLayoutValues(initialLayoutValues);
    setAddedLayout(true);
    }
};

const handleDeleteLayoutFromArray = (id) => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        deleteVideoLayoutAction({
        apiPayloadRequest: {
            _id: id,
            videoObjId: videoInputs?._id,
        },
        callback: (res) => {
            if (res?.type === 1) {
            const updatedArray = layoutArray.filter((item) => item._id !== id);
            setLayoutArray(updatedArray);
            Toastiy("Layout Deleted Successfully!", 1);
            }
        },
        })
    );
    } else {
    const updatedArray = layoutArray.filter((item) => item._id !== id);
    setLayoutArray(updatedArray);
    }
};

const handleLayoutUpdate = () => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        updateVideoLayoutAction({
        apiPayloadRequest: {
            _id: layoutValues?._id,
            videoObjId: videoInputs?._id,
            order: layoutValues?.order,
            // title: layoutArray._id,
            // subtitle: layoutArray._id,
            // expiry: layoutArray._id,
        },
        callback: (res) => {
            if (res?.type === 1) {
            setLayoutValues(initialLayoutValues);
            setIsLayoutEdit(false);
            Toastiy("Layout Updated Successfully!", 1);
            setShowNavigationAlert(false);
            }
        },
        })
    );
    } else {
    setLayoutValues(initialLayoutValues);
    setIsLayoutEdit(false);
    setShowNavigationAlert(true);
    }
};

const handleDateChange = (value) => {
    setLayoutValues((prev) => ({
    ...prev,
    expiry: value,
    }));
    setShowNavigationAlert(true);
};

const handleVideoLayoutChange = (event) => {
    if (isLayoutEdit) {
    const { name, value } = event.target;
    setLayoutValues((prev) => ({
        ...prev,
        [name]: value,
    }));

    setLayoutArray((prev) => {
        const updatedArray = [...prev];

        updatedArray[editLayoutIndex] = {
        ...updatedArray[editLayoutIndex],
        [name]: value,
        };
        return updatedArray;
    });
    } else {
    const { name, value } = event.target;
    setLayoutValues((prev) => ({
        ...prev,
        [name]: value,
    }));
    setShowNavigationAlert(true);
    }
};

const handleVideoDateChange = (value) => {
    setLayoutValues((prev) => ({
    ...prev,
    expiry: value,
    }));
    setShowNavigationAlert(true);
};

const handleDropdownChange = (selectedValues) => {
                const videoItem = {
    value: selectedValues?._id,
    label: selectedValues?.video_title,
    image:
        selectedValues?.tumbnailurls?.length > 0 ? selectedValues?.tumbnailurls[0]?.url_link : "",
    order:
        selectedRelatedVideoIndex !== null
        ? selectedOptions[selectedRelatedVideoIndex]?.order
        : selectedOptions?.length + 1,
    };

    if (data?._id !== "" && data?._id !== undefined) {
    if (selectedRelatedVideoIndex !== null && selectedOptions[selectedRelatedVideoIndex]?.value) {
        dispatch(
        deleteVideosrelatedAction({
            apiPayloadRequest: {
            _id: data?._id,
            videoObjId: selectedOptions[selectedRelatedVideoIndex]?.value,
            },
            callback: (res) => {
            if (res?.type === 1) {
                //show message
                dispatch(
                saveVideosrelatedAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    videoObjId: videoItem?.value,
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Related Video Updated Successfully!", 1);
                        setSelectedOptions((prev) =>
                        prev?.map((d, i) => (i === selectedRelatedVideoIndex ? videoItem : d))
                        );
                    } else {
                        Toastiy("Failed to Update Video");
                    }
                    },
                })
                );
            }
            },
        })
        );
    } else {
        dispatch(
        saveVideosrelatedAction({
            apiPayloadRequest: {
            _id: data?._id,
            videoObjId: videoItem?.value,
            },
            callback: (res) => {
            if (res?.type === 1) {
                Toastiy("Related Video Added Successfully!", 1);
                setSelectedOptions((prev) => [...prev, videoItem]);
            } else {
                Toastiy("Failed to Add Video");
            }
            },
        })
        );
    }
    } else {
    if (selectedRelatedVideoIndex !== null) {
        setSelectedOptions((prev) =>
        prev?.map((d, i) => (i === selectedRelatedVideoIndex ? videoItem : d))
        );
    } else {
        setSelectedOptions((prev) => [...prev, videoItem]);
    }
    setShowNavigationAlert(true);
    }
    setShowVideoLibraryModal(false);
    setVideoErrors({ ...videoErrors, selectedOptions: false });
    setSelectedRelatedVideoIndex(null);
};

const deleteRelatedVideo = (videoObjId) => {
    if (data?._id) {
    dispatch(
        deleteVideosrelatedAction({
        apiPayloadRequest: {
            _id: data?._id,
            videoObjId: videoObjId,
        },
        callback: (res) => {
            if (res?.type === 1) {
            Toastiy("Related Video Removed Successfully!", 1);
            setSelectedOptions((prev) => prev.filter((item) => item.value !== videoObjId));
            } else {
            Toastiy("Failed to Delete Video");
            }
        },
        })
    );
    } else {
    setSelectedOptions((prev) => prev.filter((item) => item.value !== videoObjId));
    }
    setSelectedRelatedVideoIndex(null);
};


const getAllLanguageResponse = (response) => {
    if (response?.type === 1) {
    setReadLanguageData(response?.data);
    setLoading(false);
    }
};

const handleInputChange = (event, setState) => {
    const { name, value } = event.target;
            setChurchInputs((prev) => ({
        ...prev,
        logo_url: value,   // 👈 directly update logo_url
      }));
        // setState((prevData) => ({
    // ...prevData,
    // [name]: value,
    // }));
    setVideoErrors({
    ...videoErrors,
    video_urls: false,
    video_download_urls: false,
    video_thumbnails_urls: false,
    video_common_thumbnails_urls: false,
    video_preview_urls: false,
    });
    setShowNavigationAlert(true);
};
const handleInputsChange = (event, setState) => {
    const { name, value } = event.target;
            setState((prevData) => ({
      ...prevData,
      [name]: value,
    }));
        setVideoErrors({
      ...videoErrors,
      video_urls: false,
      video_download_urls: false,
      video_thumbnails_urls: false,
      video_common_thumbnails_urls: false,
      video_preview_urls: false,
    });
    setShowNavigationAlert(true);
  };

const handleDownloadInputChange = (event) => {
    const { name, value } = event.target;
    setDownloadUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_download_urls: false });
    setShowNavigationAlert(true);
};

const handleTumbNailInputChange = (event) => {
    const { name, value } = event.target;
    setTumbNailUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
    setShowNavigationAlert(true);
};

const handleCommonTumbNailInputChange = (event) => {
    const { name, value } = event.target;
    setCommonUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
    setShowNavigationAlert(true);
};

const handleChange = (event) => {
    const { name, value } = event.target;
        setChurchInputs((prevData) => ({
    ...prevData,
    [name]: value,
}));
setChurchErrors({ ...churchErrors, [name]: false });
setShowNavigationAlert(true);
};
const handleCarecellChange =(event)=>{
    const { name, value } = event.target;
        setcarecellInputs((prevData) => ({
    ...prevData,
    [name]: value,
}));

setChurchErrors({ ...churchErrors, [name]: false });
setShowNavigationAlert(true);
}
// useEffect(() => {
//   // Sync churchInputs.logo_url to tumbNailUrlsInputs.webUploadUrl
//   if (churchInputs.logo_url) {
//     setTumbNailUrlsInputs(prev => ({
//       ...prev,
//       webUploadUrl: churchInputs.logo_url
//     }));
//   }
// }, [churchInputs.logo_url]);
const handleFileInputChange = (
    setState,
    keyName,
    file,
    type,
    uploadProgressId = null,
    downloadable = false,
    errorKeyName = ""
  ) => {
    if (!file) {
            return;
    }


    setLoading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("downloadable", downloadable);

    // ✅ Ensure latest state using refs inside callback
    const callback = (res) => {

      if (!res?.url) {
                setLoading(false);
        return;
      }

      const uploadedUrl = res.url;
      setState((prev) => ({
        ...prev,
        [keyName]: uploadedUrl,
      }));

      // ✅ Update both states safely
      setChurchInputs((prev) => {
        const updated = { ...prev, logo_url: uploadedUrl };
                return updated;
      });

      setTumbNailUrlsInputs((prev) => {
        const updated = { ...prev, webUploadUrl: uploadedUrl };
                return updated;
      });

      // ✅ Clear any validation errors
      setVideoErrors((prev) => ({
        ...prev,
        [errorKeyName]: false,
      }));

      setLoading(false);
      setShowNavigationAlert(true);
    };

    // ✅ Upload through saga
    if (type === "videos") {
            dispatch(
        uploadVideosV2Action({
          apiPayloadRequest: formData,
          uploadProgressId,
          callback,
        })
      );
    } else {
            dispatch(
        uploadAssestsV2Action({
          apiPayloadRequest: formData,
          uploadProgressId,
          callback,
        })
      );
    }
  };

  const handleFilesInputChange = (
    setState,
    keyName,
    file,
    type,
    uploadProgressId = null,
    downloadable = false,
    errorKeyName = ""
  ) => {

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("downloadable", downloadable);
    if (type === "videos") {
      dispatch(
        uploadVideosV2Action({
          apiPayloadRequest: formData,
          uploadProgressId: uploadProgressId,
          callback: (res) => {
            setState((prevInputs) => ({
              ...prevInputs,
              [keyName]: res?.url,
            }));
            setVideoErrors({ ...videoErrors, [errorKeyName]: false });
            setLoading(false);
            setShowNavigationAlert(true);
          },
        })
      );
    } else {
      dispatch(
        uploadAssestsV2Action({
          apiPayloadRequest: formData,
          uploadProgressId: uploadProgressId,
          callback: (res) => {
            setState((prevInputs) => ({
              ...prevInputs,
              [keyName]: res?.url,
            }));
            setVideoErrors({ ...videoErrors, [errorKeyName]: false });
            setLoading(false);
            setShowNavigationAlert(true);
          },
        })
      );
    }
  };


const handleFileDownloadInputChange = (language, field, file, value) => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(
    uploadAssestsAction({
        apiPayloadRequest: formData,
        callback: (res) => {
        setDownloadUrl(res?.url);
        setDownloadUrlsInputs((prevInputs) => ({
            ...prevInputs,
            [field]: res?.url,
        }));
        setVideoErrors({ ...videoErrors, video_download_urls: false });
        setShowNavigationAlert(true);
        },
    })
    );
    setDownloadValues(value);
};

const handleFiletumbNailInputChange = (language, field, file, value) => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(
    uploadAssestsAction({
        apiPayloadRequest: formData,
        callback: (res) => {
        setThumbNailUrl(res?.url);
        setTumbNailUrlsInputs((prevInputs) => ({
            ...prevInputs,
            [field]: res?.url,
        }));
        setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
        setShowNavigationAlert(true);
        },
    })
    );
    setThumbNailValues(value);
};

const handleRelatedVideosChange = (selectedOptions) => {
    setInputs((prevInputs) => ({
    ...prevInputs,
    [activeTab]: {
        ...prevInputs[activeTab],
        relatedVideos: selectedOptions.map((option) => option.value),
    },
    }));
    setShowNavigationAlert(true);
    // setVideoErrors({ ...videoErrors, selectedOptions: false });
};

const handleVideoDescriptionChange = (e) => {
    handleInputChange(activeTab, "videoDescription", e.target.value);
    setShowNavigationAlert(true);
};

const videoData =
    videoUrlsInputs.mobileUploadUrl !== ""
    ? videoUrlsInputs.mobileUploadUrl
    : videoUrlsInputs.webUploadUrl !== ""
    ? videoUrlsInputs.webUploadUrl
    : videoUrlsInputs.tabletUploadUrl;

const downloadData =
    UdownloadrlsInputs.mobileUploadUrl !== ""
    ? UdownloadrlsInputs.mobileUploadUrl
    : UdownloadrlsInputs.webUploadUrl !== ""
    ? UdownloadrlsInputs.webUploadUrl
    : UdownloadrlsInputs.tabletUploadUrl;

const tumbNailData =
    tumbNailUrlsInputs.mobileUploadUrl !== ""
    ? tumbNailUrlsInputs.mobileUploadUrl
    : tumbNailUrlsInputs.webUploadUrl !== ""
    ? tumbNailUrlsInputs.webUploadUrl
    : tumbNailUrlsInputs.tabletUploadUrl;


    const handleSave = (id, onClose) => {
      return new Promise((resolve, reject) => {
        if (typeof setSavingChurch === "function") setSavingChurch(true);

        const memberPayload = {
          _id: id || "",
          memberName: churchInputs?.memberName || "",
          memberDescription: churchInputs?.memberDescription || "",
          memberDesignation: churchInputs?.memberDesignation || "",
          memberProfilepicUrl:
            tumbNailUrlsInputs?.webUploadUrl || churchInputs?.logo_url || "",
        };

        dispatch(
          saveTeamRequest({
            apiPayloadRequest: memberPayload,
            callback: (res) => {
              if (typeof setSavingChurch === "function") setSavingChurch(false);

              if (res?.type !== 1) {
                toast.error("Failed to save team member");
                reject(res);
                return;
              }

              const memberObjId = res?.data?.memberObjId || res?.memberObjId;

              // =========================
              // SAVE COVER IMAGES
              // =========================
              const coverImages = ImageSet?.target?.value || [];
              coverImages.forEach((img) => {
                dispatch(
                  saveTeamCoverImageRequest({
                    apiPayloadRequest: {
                      _id: id,
                      memberObjId,
                      galleryObjId: img?.id,
                      mobilesetting: img?.mobile?.setting || "fill",
                      tabletsetting: img?.tablet?.setting || "contain",
                      dashboardsetting: img?.web?.setting || "cover",
                      default: img?.default ? "true" : "false",
                    },
                  })
                );
              });

              // =========================
              // SAVE VIDEOS (ARRAY)
              // =========================
              selectedVideos.forEach((video) => {
                dispatch(
                  saveTeamVideoRequest(
                    {
                      _id: id,
                      memberObjId,
                      videoObjId: video?.id,
                      default: video?.default ? "true" : "false",
                      live: video?.live ? "true" : "false",
                    },
                    () => {}
                  )
                );
              });

              toast.success("Team saved successfully");
              onClose();
              resolve(res);
            },
          })
        );
      });
    };











        const handleSaveCarecellCoverImage = (rowData) => {
                                        const payload = {
                      _id: rowData?.churchId || "", // church id
                      memberObjId: rowData?.memberObjId || "",
                      type_of_url: carecellInputs?.type_of_url || "",
                      url_link: carecellInputs?.url_link || "",
                    };
                                      dispatch(
                        saveTeamCoverImageRequest({
                        apiPayloadRequest: payload,
                        callback: (res) => {
                          if (res.type === 1) {
                            toast.success("Cover Image Saved Successfully ");
                          } else {
                            toast.error("Save failed: " + res.error);
                          }
                        },
                      })
                    );
                  };

                  const handleUpdateChurch = (rowData, onClose) => {
                    return new Promise((resolve, reject) => {
                      if (typeof setSavingChurch === "function") setSavingChurch(true);

                      // =========================
                      // UPDATE BASIC MEMBER
                      // =========================
                      const memberPayload = {
                        _id: rowData?.churchId,
                        memberObjId: rowData?.memberObjId,
                        memberName: churchInputs?.memberName || rowData?.memberName,
                        memberDescription:
                          churchInputs?.memberDescription || rowData?.memberDescription,
                        memberDesignation:
                          churchInputs?.memberDesignation || rowData?.memberDesignation,
                        memberProfilepicUrl:
                          churchInputs?.logo_url || rowData?.memberProfilepicUrl,
                      };

                      dispatch(
                        updateTeamRequest({
                          apiPayloadRequest: memberPayload,
                          callback: (res) => {
                            if (typeof setSavingChurch === "function") setSavingChurch(false);

                            if (res?.type !== 1) {
                              toast.error("Update failed");
                              reject(res);
                              return;
                            }

                            // =========================
                            // COVER IMAGE DIFF
                            // =========================
                            const existingCoverIds =
                              rowData?.membercoverimage?.map((i) => i.galleryObjId) || [];

                            const selectedCoverImages = ImageSet?.target?.value || [];

                            const newCoverImages = selectedCoverImages.filter(
                              (img) => !existingCoverIds.includes(img.id)
                            );

                            newCoverImages.forEach((img) => {
                              dispatch(
                                saveTeamCoverImageRequest({
                                  apiPayloadRequest: {
                                    _id: rowData?.churchId,
                                    memberObjId: rowData?.memberObjId,
                                    galleryObjId: img?.id,
                                    mobilesetting: img?.mobile?.setting || "fill",
                                    tabletsetting: img?.tablet?.setting || "contain",
                                    dashboardsetting: img?.web?.setting || "cover",
                                    default: img?.default ? "true" : "false",
                                  },
                                })
                              );
                            });

                            // =========================
                            // VIDEO DIFF (ARRAY)
                            // =========================
                            const existingVideoIds =
                              rowData?.membervideos?.map((v) => v?.video?._id) || [];

                            const newVideos = selectedVideos.filter(
                              (v) => !existingVideoIds.includes(v.id)
                            );

                            newVideos.forEach((video) => {
                              dispatch(
                                saveTeamVideoRequest(
                                  {
                                    _id: rowData?.churchId,
                                    memberObjId: rowData?.memberObjId,
                                    videoObjId: video?.id,
                                    default: video?.default ? "true" : "false",
                                    live: video?.live ? "true" : "false",
                                  },
                                  () => {}
                                )
                              );
                            });

                            toast.success("Team updated successfully");
                            onClose();
                            resolve(res);
                          },
                        })
                      );
                    });
                  };













// const getSaveVideosResponse = (response) => {
//     const leng = response?.data?.length - 1;
//     const id = response?.data[leng]?._id;
//     const keysArray = Object.keys(videoUrlsInputs);

//     if (response.type === 1) {
//     keysArray.map((item, index) => {
//         setTimeout(() => {
//         dispatch(
//             saveVideosUrlsAction({
//             apiPayloadRequest: {
//                 _id: id,
//                 type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
//                 url_link: videoUrlsInputs[item],
//             },
//             callback: (res) => {
//                 if (res?.type !== 1) {
//                 Toastiy("Failed to Video URLS");
//                 } else {
//                 setShowNavigationAlert(false);
//                 }
//             },
//             })
//         );
//         }, 500 * (index + 1));
//     });

//     keysArray.map((item, index) => {
//         setTimeout(() => {
//         dispatch(
//             saveVideosDownloadUrlsAction({
//             apiPayloadRequest: {
//                 _id: id,
//                 type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
//                 url_link: UdownloadrlsInputs[item],
//             },
//             callback: (res) => {
//                 if (res?.type !== 1) {
//                 Toastiy("Failed to Video Download URLS");
//                 } else {
//                 setShowNavigationAlert(false);
//                 }
//             },
//             })
//         );
//         }, 1000 * (index + 1));
//     });

//     keysArray.map((item, index) => {
//         setTimeout(() => {
//         dispatch(
//             saveVideosThumbNailUrlsAction({
//             apiPayloadRequest: {
//                 _id: id,
//                 type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
//                 url_link: tumbNailUrlsInputs[item],
//             },
//             callback: (res) => {
//                 if (res?.type !== 1) {
//                 Toastiy("Failed to Thumbnail URLS");
//                 } else {
//                 setShowNavigationAlert(false);
//                 // Toastiy("Video Saved Successfully!", 1);
//                 }
//             },
//             })
//         );
//         }, 500 * (index + 1));
//     });

//     keysArray.map((item, index) => {
//         setTimeout(() => {
//         if (commonVideoUrlsInputs[item]) {
//             dispatch(
//             saveCommonsUrlsAction({
//                 apiPayloadRequest: {
//                 _id: id,
//                 type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
//                 url_link: commonVideoUrlsInputs[item],
//                 },
//                 callback: (res) => {
//                 if (res?.type !== 1) {
//                     Toastiy("Failed to Thumbnail URLS");
//                 } else {
//                     setShowNavigationAlert(false);
//                     // Toastiy("Video Saved Successfully!", 1);
//                 }
//                 },
//             })
//             );
//         }
//         }, 600 * (index + 1));
//     });

//     keysArray.map((item, index) => {
//         setTimeout(() => {
//         if (previewUrlsInputs[item]) {
//             dispatch(
//             saveVideoPreviewUrlsAction({
//                 apiPayloadRequest: {
//                 _id: id,
//                 type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
//                 url_link: previewUrlsInputs[item],
//                 },
//                 callback: (res) => {
//                 if (res?.type !== 1) {
//                     Toastiy("Failed to Preview URLS");
//                 } else {
//                     setShowNavigationAlert(false);
//                     // Toastiy("Video Saved Successfully!", 1);
//                 }
//                 },
//             })
//             );
//         }
//         }, 600 * (index + 1));
//     });

//     selectedOptions.map((item, index) => {
//         setTimeout(() => {
//         dispatch(
//             saveVideosrelatedAction({
//             apiPayloadRequest: {
//                 _id: id,
//                 videoObjId: item?.value,
//             },
//             })
//         );
//         }, 600 * (index + 1));
//     });

//     layoutArray.map((item, index) => {
//         setTimeout(() => {
//         dispatch(
//             saveVideoLayoutAction({
//             apiPayloadRequest: {
//                 _id: item?._id,
//                 videoObjId: id,
//                 order: item?.order,
//                 // expiry: item?.expiry,
//                 // title: item?.title,
//                 // subtitle: item?.subtitle,
//             },
//             callback: (res) => {
//             },
//             })
//         );
//         }, 700 * (index + 1));
//     });
//     setTimeout(() => {
//         setLoading(false);
//         Toastiy("Video Updated Successfully!", 1);
//         navigate("/videos/all");
//     }, 3000);
//     } else {
//     Toastiy("Failed To Save Video");
//     }
//     setLoading(false);
// };

// mobileUploadUrl: '',
// webUploadUrl: '',
// tabletUploadUrl: '', saveVideosThumbNailUrlsAction

// const getSaveVideosResponse1 = (data, id, message) => {
//     if (data?.type === 1) {
//     Toastiy(message, data?.type);
//     dispatch(
//         saveVideosDownloadUrlsAction({
//         apiPayloadRequest: {
//             _id: id,
//             type_of_url: downloadValues,
//             url_link: downloadData,
//         },
//         callback: (res) =>
//             getSaveVideosResponse2(res, id, "Video Download Url Saved Sucessfully."),
//         })
//     );
//     } else {
//     Toastiy("Issue performing the operation, contact admin!!", data?.type);
//     }
// };

// const getSaveVideosResponse2 = (data, id, message) => {
//     if (data?.type === 1) {
//     Toastiy(message, data?.type);
//     dispatch(
//         saveVideosThumbNailUrlsAction({
//         apiPayloadRequest: {
//             _id: id,
//             type_of_url: thumbNailValues,
//             url_link: tumbNailData,
//         },
//         callback: (res) => getSaveVideosResponse3(res, "Video Tumbnail Url Saved Sucessfully."),
//         })
//     );
//     } else {
//     Toastiy("Issue performing the operation, contact admin!!", data?.type);
//     }
// };

const getSaveVideosResponse3 = (data, message) => {
    if (data?.type === 1) {
    Toastiy(message, data?.type);
    } else {
    Toastiy("Issue performing the operation, contact admin!!", data?.type);
    }
};

// useEffect(() => {
//     setLoading(true);
//     dispatch(
//     readLanguageAction({
//         callback: getAllLanguageResponse,
//     })
//     );
// }, []);

const fetchVideoDetails = () => {
    dispatch(
    readVideosAction({
        apiPayloadRequest: {
        _id: data?._id,
        },
        callback: (res) => {
        const data = res?.data[0];
        // setVideoInputs({
        //   _id: data?._id,
        //   video_title: data?.video_title || "",
        //   video_description: data?.video_description || "",
        // });

        setCurrentInputs({
            _id: data?._id,
            video_title: data?.video_title || "",
            video_description: data?.video_description || "",
            totalLikes: data?.totallikes || 0,
            totalViews: data?.video_views || 0,
        });

        setLanguagemeta(data?.languagemetas);
        // setVideoUrlsInputs({
        //   mobileUploadUrl:
        //     data?.urls?.filter((item) => item.type_of_url === "0")[0]
        //       .url_link || "",
        //   webUploadUrl:
        //     data?.urls?.filter((item) => item.type_of_url === "1")[0]
        //       .url_link || "",
        //   tabletUploadUrl:
        //     data?.urls?.filter((item) => item.type_of_url === "2")[0]
        //       .url_link || "",
        // });

        setVideoUrlsInputsCheck({
            mobileUploadUrl:
            data?.urls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl: data?.urls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.urls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        // setDownloadUrlsInputs({
        //   mobileUploadUrl:
        //     data?.downloadurls?.filter(
        //       (item) => item.type_of_url === "0"
        //     )[0].url_link || "",
        //   webUploadUrl:
        //     data?.downloadurls?.filter(
        //       (item) => item.type_of_url === "1"
        //     )[0].url_link || "",
        //   tabletUploadUrl:
        //     data?.downloadurls?.filter(
        //       (item) => item.type_of_url === "2"
        //     )[0].url_link || "",
        // });

        setDownloadUrlsInputsCheck({
            mobileUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        setTumbNailUrlsInputsCheck({
            mobileUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        setCommonUrlsInputsCheck({
            mobileUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "0")[0].url_link ||
            "",
            webUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "1")[0].url_link ||
            "",
            tabletUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "2")[0].url_link ||
            "",
        });

        setPreviewUrlsInputsCheck({
            mobileUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        // const isValidRelatedVideos = data?.relatedvideos?.find((v) => v?.videoObjId?.length > 0);
        // const relatedVideos = isValidRelatedVideos ? data?.relatedvideos : [];
        const relatedVideos = data?.relatedvideos ?? [];
        const relatedVideosList = [];
        relatedVideos.map((item) => {
            relatedVideosList.push({
            value: item?.videoObjId?._id,
            label: item?.videoObjId?.video_title,
            image: item?.videoObjId?.tumbnailurls[0].url_link,
            });
        });
        setSelectedOptions(relatedVideosList);
        },
    })
    );
};



const [isLanguageSave, setIsLanguageSave] = useState(true);
const [currentLanguageInputs, setCurrentLanguageInputs] = useState();
const [currentLanguageUrlCheck, setCurrentLanguageUrlCheck] = useState();
const [currentLanguageDownloadUrlCheck, setCurrentLanguageDownloadUrlCheck] = useState();
const [currentLanguagePreviewUrlCheck, setCurrentLanguagePreviewUrlCheck] = useState();


// useEffect(() => {
//     if (activeTab === "en") {
//     if (currentInputs) {
//         setVideoInputs(currentInputs);
//     }
//     if (videoUrlsInputsCheck) {
//         setVideoUrlsInputs(videoUrlsInputsCheck);
//     }
//     if (UdownloadrlsInputsCheck) {
//         setDownloadUrlsInputs(UdownloadrlsInputsCheck);
//     }
//     if (tumbNailUrlsInputsCheck) {
//         setTumbNailUrlsInputs(tumbNailUrlsInputsCheck);
//     }
//     if (commonUrlsInputsCheck) {
//         setCommonUrlsInputs(commonUrlsInputsCheck);
//     }
//     if (previewUrlsInputsCheck) {
//         setPreviewUrlsInputs(previewUrlsInputsCheck);
//     }
//     } else {
//     const isPresent = languagemeta?.some((language) => language?.language_code === activeTab);
//     if (isPresent) {
//         const data = languagemeta?.filter((item) => item?.language_code === activeTab)[0];

//         setVideoInputs((prev) => ({
//         ...prev,
//         video_title: data?.video_title || "",
//         video_description: data?.video_description || "",
//         }));
//         setCurrentLanguageInputs((prev) => ({
//         ...prev,
//         video_title: data?.video_title || "",
//         video_description: data?.video_description || "",
//         }));

//         if (data?.urls?.length > 0) {
//         setVideoUrlsInputs({
//             mobileUploadUrl:
//             data?.urls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
//             webUploadUrl:
//             data?.urls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
//             tabletUploadUrl:
//             data?.urls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
//         });
//         setCurrentLanguageUrlCheck({
//             mobileUploadUrl:
//             data?.urls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
//             webUploadUrl:
//             data?.urls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
//             tabletUploadUrl:
//             data?.urls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
//         });
//         } else {
//         setVideoUrlsInputs(initialStateValues);
//         setCurrentLanguageUrlCheck(initialStateValues);
//         }
//         if (data?.downloadurls?.length > 0) {
//         setDownloadUrlsInputs({
//             mobileUploadUrl:
//             data?.downloadurls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
//             webUploadUrl:
//             data?.downloadurls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
//             tabletUploadUrl:
//             data?.downloadurls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
//         });
//         setCurrentLanguageDownloadUrlCheck({
//             mobileUploadUrl:
//             data?.downloadurls?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
//             webUploadUrl:
//             data?.downloadurls?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
//             tabletUploadUrl:
//             data?.downloadurls?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
//         });
//         } else {
//         setDownloadUrlsInputs(initialStateValues);
//         setCurrentLanguageDownloadUrlCheck(initialStateValues);
//         }
//         if (data?.trailers?.length > 0) {
//         setPreviewUrlsInputs({
//             mobileUploadUrl:
//             data?.trailers?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
//             webUploadUrl:
//             data?.trailers?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
//             tabletUploadUrl:
//             data?.trailers?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
//         });
//         setCurrentLanguagePreviewUrlCheck({
//             mobileUploadUrl:
//             data?.trailers?.filter((item) => item?.type_of_url === "0")?.[0]?.url_link || "",
//             webUploadUrl:
//             data?.trailers?.filter((item) => item?.type_of_url === "1")?.[0]?.url_link || "",
//             tabletUploadUrl:
//             data?.trailers?.filter((item) => item?.type_of_url === "2")?.[0]?.url_link || "",
//         });
//         } else {
//         setPreviewUrlsInputs(initialStateValues);
//         setCurrentLanguagePreviewUrlCheck(initialStateValues);
//         }
//     } else {
//         setVideoInputs(currentInputs);
//         setCurrentLanguageInputs(currentInputs);
//         setVideoUrlsInputs(initialStateValues);
//         setCurrentLanguageUrlCheck(initialStateValues);
//         setDownloadUrlsInputs(initialStateValues);
//         setCurrentLanguageDownloadUrlCheck(initialStateValues);
//         setPreviewUrlsInputs(initialStateValues);
//         setCurrentLanguagePreviewUrlCheck(initialStateValues);
//     }
//     }
// }, [
//     activeTab,
//     videoUrlsInputsCheck,
//     UdownloadrlsInputsCheck,
//     tumbNailUrlsInputsCheck,
//     commonUrlsInputsCheck,
//     previewUrlsInputsCheck,
// ]);


const handleSaveLanguage = async () => {
      const requestsList = [];
    if (isLanguageSave) {
    const keysArray = Object.keys(churchInputs);

    const apiPayloadRequest = {
      _id: data?.church?._id, // ✅ Leadership ID
      language_code: activeTab, // ✅ Current active language
      memberName: churchInputs?.memberName, // ✅ Leader name
      memberDesignation: churchInputs?.memberDesignation, // ✅ Designation
      memberDescription: churchInputs?.memberDescription, // ✅ Optional description
    };


    requestsList.push(
      new Promise((resolve, reject) => {

        dispatch(
          saveLeadershipLanguageMetaRequest(apiPayloadRequest, (res) => {
                        if (res?.type === 1) {
              // Toastiy("Leadership Language Saved Successfully", 1);
              setShowNavigationAlert(false);
            } else {
              Toastiy("Failed to Save Leadership Language", 0);
            }
            resolve();
          })
        );
      })
    );

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (videoUrlsInputs[item]) {
                dispatch(
                saveVideoUrlLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 500);
        })
        );
    });

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (UdownloadrlsInputs[item]) {
                dispatch(
                saveDownloadVideoUrlLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video Download URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 600);
        })
        );
    });

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (previewUrlsInputs[item]) {
                dispatch(
                saveVideoPreviewLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video Preview URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 650);
        })
        );
    });
    } else {
    const keysArray = Object.keys(videoUrlsInputs);

    if (
        videoInputs?.video_title !== currentLanguageInputs?.video_title ||
        videoInputs?.video_description !== currentLanguageInputs?.video_description
    ) {
        requestsList.push(
        new Promise((resolve, reject) => {
            dispatch(
            updateVideoLanguageAction({
                apiPayloadRequest: {
                _id: data?._id,
                language_code: activeTab,
                video_title: videoInputs?.video_title,
                video_description: videoInputs?.video_description,
                },
                callback: (res) => {
                if (res?.type === 1) {
                    Toastiy("Video Language Updated Successfully", 1);
                    setShowNavigationAlert(false);
                }
                resolve();
                },
            })
            );
        })
        );
    }

    keysArray.map((item) => {
        if (!currentLanguageUrlCheck[item] && videoUrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        videoUrlsInputs[item] &&
        videoUrlsInputs[item] !== currentLanguageUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });

    keysArray.map((item) => {
        if (!currentLanguageDownloadUrlCheck[item] && UdownloadrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveDownloadVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Download URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        UdownloadrlsInputs[item] &&
        UdownloadrlsInputs[item] !== currentLanguageDownloadUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateDownloadVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Download URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });

    keysArray.map((item) => {
        if (!currentLanguagePreviewUrlCheck[item] && previewUrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveVideoPreviewLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Preview URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        previewUrlsInputs[item] &&
        previewUrlsInputs[item] !== currentLanguagePreviewUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateVideoPreviewLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Preview URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });
    }

    await Promise.all(requestsList);
    fetchVideoDetails();
};

const handleLibraryVideoSelection = (details) => {
        setVideoInputs((prev) => ({
    ...prev,
    video_title: details?.video_title,
    video_description: details?.video_description,
    }));
    setVideoUrlsInputs({
    mobileUploadUrl: details?.urls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.urls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.urls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setDownloadUrlsInputs({
    mobileUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setTumbNailUrlsInputs({
    mobileUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setCommonUrlsInputs({
    mobileUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setShowNavigationAlert(true);
};

const handleSendNotification = () => {
    dispatch(
    sendCustomNotificationAction({
        apiPayloadRequest: {
        _id: data?._id,
        type: "2",
        },
        callback: (res) => {
        if (res?.type === 1) {
            Toastiy("Notification Sent Successfully", 1);
        }
        },
    })
    );
};

return {
    value,
    onChangeSearchBar,
    languages,
    activeTab,
    setActiveTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    inputs,
    handleInputChange,
    handleInputsChange,
    handleFileInputChange,
    handleFilesInputChange,
    handleRelatedVideosChange,
    handleVideoDescriptionChange,
    handleSave,
    handleSaveCarecellCoverImage,
    readLanguageData,
    videoInputs,
    videoErrors,
    showVideoLibraryModal,
    setShowVideoLibraryModal,
    setVideoUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    videoUrlsInputs,
    handleFileDownloadInputChange,
    handleFiletumbNailInputChange,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange,
    handleCarecellChange,
    handleTumbNailInputChange,
    handleDownloadInputChange,
    selectedOptions,
    setSelectedOptions,
    deleteRelatedVideo,
    setSelectedRelatedVideoIndex,
    handleDropdownChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleDateChange,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    handleVideoDateChange,
    options,
    handleDeleteLayoutFromArray,
    setIsLayoutEdit,
    setEditLayoutIndex,
    isLayoutEdit,
    handleLayoutUpdate,
    setEditTargetLayout,
    editTargetLayout,
    updateStateWithTranslation,
    handleCommonTumbNailInputChange,
    setCommonUrlsInputs,
    commonVideoUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    selectedVideos, setSelectedVideos,
    handleLibraryVideoSelection,
    currentInputs,
    handleSendNotification,
    churchInputs, // instead of videoInputs
    churchErrors, // instead of videoErrors
    handleChange,
    handleSave,
    handleUpdateChurch,
    setImageset,
    churchInputs, setChurchInputs,
    setLanguagemeta,
    thumbnailImage, setThumbnailImage,
    isLive,setIslive,
    isDefault,setIsDefault
};
};
